import _sortBy from 'lodash/sortBy';
import { asDictionary } from '@/transformations/service-catalog-attributes';

const INSURANCE_ATTR = 'insured_amt';
const LICENSE_TYPE = 'license';
const TOP_PRO = 'pro_badge_eligible';

// TODO(alok|adam) - use this in rsf

export function createPublicProfile (data) {
  const serviceProvider = data.service_provider || {};
  const attributeValues = asDictionary(
    serviceProvider.attribute_values || [],
    'service_provider_attribute',
    'value'
  );
  const insuredAmount = attributeValues[INSURANCE_ATTR] || 0;
  const documents = data.documents || [];
  const licenseDocuments = documents.filter(document => document.document_type === LICENSE_TYPE);
  const topPro = attributeValues[TOP_PRO] || null;

  return {
    ...data,
    servicesList: _sortBy(data.services || [], 'name'),
    name: serviceProvider.business_name || '',
    occupationName: (data.occupation_name || '').replace(/_/g, ' '),
    logo: encodeURI(serviceProvider.logo || ''), // Logo url might have spaces in it
    addressInfo: (serviceProvider.addresses || []).reduce((acc, next) => (
      { ...acc, [next.address_type]: next }
    ), {}),
    contactInfo: (serviceProvider.contacts || []).reduce((acc, next) => (
      { ...acc, [next.contact_type]: next.contact }
    ), {}),
    ratingInfo: {
      average: data.rating_average || 0,
      count: data.rating_count || 0,
    },
    insuranceInfo: {
      isInsured: Boolean(insuredAmount),
      amount: insuredAmount,
    },
    licenseInfo: {
      isLicensed: Boolean(licenseDocuments.length),
      licenses: licenseDocuments,
    },
    get businessAddress () {
      return this.addressInfo.business;
    },
    get phone () {
      return this.contactInfo.phone;
    },
    get topPro () {
      const topProAttr = JSON.parse(topPro);
      return topProAttr;
    },
  };
}
